import { Link } from 'react-router-dom';
import { services } from '../../../mocks/services';

export default function ServicesOverview() {
  const [featured, ...rest] = services;
  const gridServices = rest.slice(0, 5);

  return (
    <section className="py-24 bg-parkside-warm">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <span className="inline-block bg-parkside-amber/12 text-parkside-amber text-xs font-bold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-3">
              What We Do
            </span>
            <h2 className="font-display text-4xl md:text-5xl text-parkside-dark leading-tight tracking-display">
              Our Paver &amp; Outdoor Services
            </h2>
            <p className="text-parkside-muted mt-3 max-w-xl text-base leading-relaxed">
              From driveway pavers to full outdoor living transformations — every project custom-built for Tampa Bay.
            </p>
          </div>
          <Link
            to="/services"
            className="flex items-center gap-2 text-parkside-green font-bold text-sm border border-parkside-green/30 px-5 py-2.5 rounded-lg hover:bg-parkside-green hover:text-white transition-all whitespace-nowrap cursor-pointer flex-shrink-0"
          >
            View All Services
            <span className="w-4 h-4 inline-flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </span>
          </Link>
        </div>

        {/* Main featured + grid layout */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 mb-5">
          {/* Featured — large card */}
          <Link
            to={featured.slug}
            className="lg:col-span-1 lg:row-span-2 group relative rounded-2xl overflow-hidden h-[420px] lg:h-auto cursor-pointer block"
            style={{ minHeight: '420px' }}
          >
            <div className="w-full h-full absolute inset-0">
              <img
                src={featured.image}
                alt={featured.title}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
              />
            </div>
            <div className="absolute inset-0 bg-gradient-to-t from-parkside-darker/90 via-parkside-darker/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-7">
              <div className="w-10 h-10 flex items-center justify-center bg-parkside-amber rounded-xl mb-4">
                <i className={`${featured.icon} text-white text-lg`} />
              </div>
              <h3 className="font-display text-white text-2xl mb-2 leading-tight">{featured.title}</h3>
              <p className="text-white/70 text-sm leading-relaxed mb-4 line-clamp-2">{featured.description}</p>
              <div className="inline-flex items-center gap-2 bg-parkside-amber/20 border border-parkside-amber/40 text-parkside-gold text-sm font-semibold px-4 py-2 rounded-lg group-hover:bg-parkside-amber group-hover:text-white transition-all">
                Learn More
                <span className="w-4 h-4 inline-flex items-center justify-center">
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </div>
          </Link>

          {/* 2-column grid of rest */}
          {gridServices.map((service) => (
            <Link
              key={service.id}
              to={service.slug}
              className="group relative rounded-2xl overflow-hidden cursor-pointer block"
              style={{ height: '200px' }}
            >
              <div className="w-full h-full absolute inset-0">
                <img
                  src={service.image}
                  alt={service.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-700"
                />
              </div>
              <div className="absolute inset-0 bg-gradient-to-t from-parkside-darker/85 via-parkside-darker/20 to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="w-8 h-8 flex items-center justify-center bg-parkside-amber rounded-lg mb-2.5">
                  <i className={`${service.icon} text-white text-sm`} />
                </div>
                <h3 className="text-white font-bold text-base leading-tight mb-1">{service.title}</h3>
                <div className="flex items-center gap-1 text-parkside-gold text-xs font-semibold">
                  Learn More
                  <span className="w-3 h-3 inline-flex items-center justify-center">
                    <i className="ri-arrow-right-line text-xs" />
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Bottom service strip */}
        <div className="grid grid-cols-1 sm:grid-cols-3 md:grid-cols-7 gap-3">
          {services.map((s) => (
            <Link
              key={s.id}
              to={s.slug}
              className="group flex flex-col items-center text-center bg-white rounded-xl p-4 border border-stone-100 hover:border-parkside-green/30 hover:bg-parkside-cream transition-all cursor-pointer"
            >
              <div className="w-9 h-9 flex items-center justify-center bg-parkside-green/10 rounded-lg mb-2 group-hover:bg-parkside-green/20 transition-colors">
                <i className={`${s.icon} text-parkside-green text-base`} />
              </div>
              <span className="text-parkside-dark text-xs font-semibold leading-tight group-hover:text-parkside-green transition-colors">{s.title}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
